import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import HomePageCard from "./HomePageCard";

type EmptyListProps = {
  sectionTitle?: string;
  title: string;
  subheader: string;
  description: string;
  buttonText?: string;
  buttonDataCy?: string;
  onButtonClick?: () => void;
  buttonComponent?: React.ReactNode;
};

const EmptyList = ({
  sectionTitle,
  title,
  subheader,
  description,
  buttonText,
  buttonDataCy,
  onButtonClick,
  buttonComponent,
}: EmptyListProps) => (
  <>
    {sectionTitle && (
      <Typography variant="h1" color="text.primary" sx={{ mb: 2 }}>
        {sectionTitle}
      </Typography>
    )}
    <HomePageCard title={title} subheader={subheader} sxProps={{ height: "100%" }}>
      <CardContent
        sx={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          p: 3,
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 500, textAlign: "center", mb: 2 }}>
          {description}
        </Typography>
        {buttonComponent ? (
          buttonComponent
        ) : (
          <Button
            variant="outlined"
            size="small"
            sx={{ mt: 1 }}
            data-cy={buttonDataCy}
            endIcon={<ArrowForwardIcon />}
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>
        )}
      </CardContent>
    </HomePageCard>
  </>
);

export default EmptyList;
